'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var modeToString = require('../lib/mode-to-string.js');

var parseMtime = require('../lib/parse-mtime.js');

var configure = require('../lib/configure.js');

var multipartRequest = require('ipfs-core-utils/multipart-request');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var abortSignal = require('../lib/abort-signal.js');

var createWrite = configure.configure(function (api) {
  function write(_x, _x2) {
    return _write.apply(this, arguments);
  }

  function _write() {
    _write = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(path, input) {
      var options,
          controller,
          signal,
          res,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              controller = new AbortController();
              signal = abortSignal.abortSignal(controller.signal, options.signal);
              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                signal: signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: path,
                  streamChannels: true,
                  count: options.length
                }, options))
              };
              _context.next = 8;
              return multipartRequest.multipartRequest([{
                content: input,
                path: 'arg',
                mode: modeToString.modeToString(options.mode),
                mtime: parseMtime.parseMtime(options.mtime)
              }], controller, options.headers);

            case 8:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 12;
              return _context.t0.post.call(_context.t0, 'files/write', _context.t4);

            case 12:
              res = _context.sent;
              _context.next = 15;
              return res.text();

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _write.apply(this, arguments);
  }

  return write;
});
exports.createWrite = createWrite;